// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__LFncy","error":"Textarea_error__geVIK","readonly":"Textarea_readonly__fMyQF","disabled":"Textarea_disabled__at9HQ"};